<!--新增编辑库存商品，基础配件转化为库存商品操作弹窗-->
<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible="dialogFormVisible"
      width="1000px"
      :show-close="true"
      :before-close="handleClose"
      append-to-body
    >
      <div v-loading="loading">
        <div class="service-main">
          <div class="service-item">
            <div class="serves-name">客户来源：</div>
            <div class="serves-content" :key="index" v-for="(item,index) in sourcesList">
              <el-button v-if="item.Id.length==0" disabled type="primary" plain>{{item.Text}}</el-button>
              <el-button
                v-show="item.Id.length>0 && !item.IsEdit"
                @click="editSource(item)"
              >{{item.Text}}</el-button>
              <el-input
                v-model.trim="item.Text"
                v-show="item.IsEdit"
                @blur="handleSourceConfirm(1,item)"
              ></el-input>
              <i
                class="el-icon-circle-close serves-del"
                @click="delItem(item)"
                v-show="item.Id.length>0 && !item.IsEdit"
              ></i>
            </div>
            <el-input
              class="input-new-tag serves-name"
              v-if="addSourceVisible"
              v-model.trim="newSource"
              ref="saveTagInput"
              @blur="handleSourceConfirm(0)"
            ></el-input>
            <el-button v-else class="button-new-tag serves-name" @click="showAddSourceInput">＋添加客户来源</el-button>
          </div>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align:right;margin-top:20px;padding-bottom: 10px;"
        >
          <el-button class="search-btn btn-primary" @click="handleClose">取消</el-button>
          <el-button class="search-btn btn-primary" @click="submitConfirm">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: "管理客户来源",
      loading: false,
      indexSourceVisible: false,
      addSourceVisible: false,
      newSource: "",
      sourcesModel: {
        Value: -1,
        Text: "",
        IsEdit: false,
      },
      sourcesList: {},
      submitData: {
        SourcesList: [],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    showAddSourceInput() {
      this.addSourceVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    getData() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpCustomers/GetEnterpriseCustomerSources",
        })
        .then((res) => {
          this.sourcesList = res.data;
          this.loading = false;
        })
        .catch(() => {});
    },
    editSource(item) {
      let target = this.sourcesList;
      for (let i = 0; i < target.length; i++) {
        if (target[i].Text == item.Text) {
          if (target[i].Id == "newSource") {
            //先删后增只为了 重新渲染
            this.sourcesList.splice(i, 1);
            item.IsEdit = !item.IsEdit;
            this.sourcesList.push(item);
          }
          else
            item.IsEdit = !item.IsEdit;
          return;
        }
      }
    },
    // 提交数据
    submitConfirm() {
      this.submitData.SourcesList = [
        ...this.sourcesList
      ];
      this.$util
        .axiosPost({
          url: "/api/EntpCustomers/SaveEnterpriseCustomerSources",
          data: this.submitData,
        })
        .then((res) => {
          this.$util.successMsg("保存成功");
          this.handleClose();
        });
    },
    delItem(item) {
      let target = this.sourcesList;
      for (let i = 0; i < target.length; i++) {
        if (target[i].Text == item.Text) {
          if (target[i].Id == "newSource") {
            this.sourcesList.splice(i, 1);
          } else {
            this.$confirm(
              "如果该来源有相关的关联会恢复默认来源，是否确认继续操作?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.sourcesList.splice(i, 1);
              })
              .catch(() => {});
          }
        }
      }
    },
    handleClose() {
      this.$emit("closeSourceDialog");
    },
    //编辑与添加
    handleSourceConfirm(type, item) {
      //新增
      if (type == 0) {
        let target = this.sourcesList;
        for (let i = 0; i < target.length; i++) {
          if (target[i].Text == this.newSource) {
            this.$util.warningMsg("该来源已存在");
            return;
          }
        }
        let inputValue = this.newSource;
        if (inputValue) {
          this.sourcesList.push({
            Id: "newSource",
            Value: -1,
            Text: inputValue,
          });
        }
        this.addSourceVisible = false;
        this.newSource = "";
      } else {
        //编辑
        let target = this.sourcesList;
        for (let i = 0; i < target.length; i++) {
          for (let j = i + 1; j < target.length; j++) {
            if (target[i].Text == target[j].Text) {
              this.$util.warningMsg("该来源已存在");
              return;
            }
          }
        }
        this.editSource(item);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.serves-name {
  margin-bottom: 20px;
}
.service-main {
  max-width: 800px;
  margin: 0 auto;
  padding-top: 50px;
}
.service-item {
  font-size: @font-md;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 50px;
}
.input-new-tag {
  width: 90px;
  margin-left: 20px;
}
.button-new-tag {
  margin-left: 20px;
}
.serves-content {
  display: flex;
  margin-bottom: 20px;
  margin-left: 10px;
}
.serves-content-default {
  display: flex;
  margin-bottom: 20px;
  margin-right: 17px;
  margin-left: 10px;
}
.serves-del {
  background-color: #ffffff;
  height: 17px;
  width: 17px;
  position: relative;
  right: 14px;
  bottom: 4px;
  color: #c2ccd0;
}
</style>